<template>
  <div
    class="bg-dark"
    :class="[viewStore.isMobile ? 'reference-mobile' : 'reference']"
  >
    <div class="d-flex justify-content-center">
      <h1 class="header-title">Referenzen</h1>
    </div>

    <div class="container py-3 mt-4" style="border-top: 1px solid #454545">
      <div
        id="accordionExample"
        class="row row-cols-md-3 row-cols-1 pb-5 accordion"
        :class="[viewStore.isMobile ? 'pt-0' : 'pt-4']"
      >
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse1"
              aria-expanded="true"
              aria-controls="collapse1"
            >
              <img
                src="../assets/images/hoerbuch/mir.webp"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse1"
              class="accordion-collapse collapse show"
              aria-labelledby="heading1"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse1"
              aria-controls="collapse1"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                VAP steht für die perfekt Soundqualität und die beste
                Tonatmosphäre! Ich bin sehr zufrieden mit der Zusammenarbeit und
                all den Projekten, in denen wir zusammengearbeitet haben. Durch
                Know-How und Expertise bekommen Hörbuch bis Podcast und
                Meditationen immer den Extra-Schliff. Sie lassen alles super
                klingen.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Laura Malina Seiler</div>
                  <div>Produkt: Hörbuch</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse2"
              aria-expanded="false"
              aria-controls="collapse2"
            >
              <img
                src="../assets/images/hoerbuch/unbaendig.jpeg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse2"
              class="accordion-collapse collapse"
              aria-labelledby="heading2"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse2"
              aria-controls="collapse2"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Ich habe mein Hörbuch 2 Tage lang mit Jakob eingesprochen und
                konnte mich durch seine ruhige, geduldige und vor allem
                entspannte Art „hinter der Scheibe“ in diese für mich neue und
                aufregende Aufgabe gut reinfinden. Jakob ist sehr aufmerksam und
                hört nicht nur die kleinen Versprecher, die einem selbst nicht
                auffallen immer raus, sondern sieht auch immer, wenn mal ans
                Sprecher*in mal eine Pause braucht. Für Pausen, lustige
                Gespräche und Kaffee ist immer Zeit, sodass man sich mit Ihm
                einfach wohlfühlt. Ich freue mich schon mein 2. Hörbuch mit ihm
                einzusprechen.“
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Michi Schreiber</div>
                  <div>Produkt: Hörbuch</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse3"
              aria-expanded="false"
              aria-controls="collapse3"
            >
              <img
                src="../assets/images/hoerbuch/geburt.png"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse3"
              class="accordion-collapse collapse"
              aria-labelledby="heading3"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3"
              aria-controls="collapse3"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Ich bin so froh, dass ich VAP gefunden habe, denn nach einer
                sehr teuren und enttäuschenden Arbeit eines anderen Tonstudios
                waren sie wirklich meine Rettung! Die Arbeit im Tonstudio mit
                Jakob war super angenehm und nett, und das Endergebnis ist genau
                so, wie ich es mir gewünscht hatte! VAP arbeitet zuverlässig,
                schnell, freundlich und kompetent. Was will man mehr?
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Kristin Graf</div>
                  <div>Produkt: Hörbuch</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse4"
              aria-expanded="false"
              aria-controls="collapse4"
            >
              <img
                src="../assets/images/hoerbuch/DRDS.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse4"
              class="accordion-collapse collapse"
              aria-labelledby="heading4"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse4"
              aria-controls="collapse4"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Ich bin total begeistert und die Kinder auch. Das Hörspiel
                überträgt genau die Gefühle & Emotionen, die ich haben wollte.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Kati Bohnet</div>
                  <div>Produkt: Hörspiel</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Saskia -->
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse5"
              aria-expanded="false"
              aria-controls="collapse5"
            >
              <img
                src="../assets/images/hoerbuch/wilma.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse5"
              class="accordion-collapse collapse"
              aria-labelledby="heading5"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse5"
              aria-controls="collapse5"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                Ohne Jakob würde es meinen Podcast und mein heißgeliebtes
                Hörspiel zu Wilma Wolkenkopf schlichtweg nicht geben. Er setzt
                meine Ideen und Inhalte auf wunderbar authentische und
                professionelle Weise um, arbeitet unheimlich verlässlich,
                bestärkt meine Arbeit und hilft durch hier und da eine kleine
                Erinnerung meinem chaotischen Gehirn. Ich fühle mich unheimlich
                gut betreut.
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Saskia Niechzial</div>
                  <div>Produkt: Hörspiel</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Laura Seiler -->
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse6"
              aria-expanded="false"
              aria-controls="collapse6"
            >
              <img
                src="../assets/images/hoerbuch/LC.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse6"
              class="accordion-collapse collapse"
              aria-labelledby="heading6"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse6"
              aria-controls="collapse6"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Laura Malina Seiler</div>
                  <div>Produkt: Hörbuch</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Laura Seiler - Sex mit dem Universum -->
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse7"
              aria-expanded="false"
              aria-controls="collapse7"
            >
              <img
                src="../assets/images/hoerbuch/SMDU.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse7"
              class="accordion-collapse collapse"
              aria-labelledby="heading7"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse7"
              aria-controls="collapse7"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Laura Malina Seiler</div>
                  <div>Produkt: Hörbuch</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Kati Bohnet - Jona ist wütend -->
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse8"
              aria-expanded="false"
              aria-controls="collapse8"
            >
              <img
                src="../assets/images/hoerbuch/JIW.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse8"
              class="accordion-collapse collapse"
              aria-labelledby="heading8"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse8"
              aria-controls="collapse8"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">
                    Kati Bohnet - Helpers Circle
                  </div>
                  <div>Produkt: Hörspiel</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Saskia Niechzial - Ein Kopf voll Gold -->
        <div class="col" :class="[viewStore.isMobile ? 'py-0' : 'py-3']">
          <div class="card" :class="[viewStore.isMobile ? '' : 'lift-effect']">
            <a
              data-bs-toggle="collapse"
              data-bs-target="#collapse9"
              aria-expanded="false"
              aria-controls="collapse9"
            >
              <img
                src="../assets/images/hoerbuch/EKVG.jpg"
                class="img-fluid rounded-3"
                alt="..."
              />
            </a>

            <div
              id="collapse9"
              class="accordion-collapse collapse"
              aria-labelledby="heading9"
              data-bs-parent="#accordionExample"
              data-bs-toggle="collapse"
              data-bs-target="#collapse9"
              aria-controls="collapse9"
            >
              <div class="accordion-body rounded-3 rounded-top-0 p-4 lh-base">
                <div class="pt-2">
                  <hr />
                  <div class="work-ref fw-bold">Saskia Niechzial</div>
                  <div>Produkt: Hörbuch</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Erstgespräch -->
    <div class="text-center fs-3 text-white fw-bold">
      <div class="reference-cta-header pb-4 lh-sm">
        Let your story come to life!
      </div>

      <a
        id="erzaehl-mal-hoerbuch"
        class="mt-5 btn btn-primary btn-lg px-5"
        href="https://calendly.com/voiceart-productions/erstgespraech"
        target="_blank"
        >Erzähl mal</a
      >
      <div class="cta-sub pt-4">Jetzt kostenloses Erstgespräch buchen</div>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();
</script>

<style scoped lang="scss">
.reference-mobile {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.reference {
  padding-top: 10rem;
  padding-bottom: 12rem;
}
.work-ref {
  color: rgb(255, 255, 255);
}

.reference-text {
  color: rgb(190, 190, 190);
}
.header-title {
  color: #fc4667;
  font-weight: 700;
  font-size: 3.5rem;
  /* background: linear-gradient(90deg, #fc4667 0%, #816cff 99%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: fit-content; */
}

.card-body {
  min-height: 300px;
  min-width: 300px;
  margin-right: 5px;
}
.accordion-body {
  background-color: rgb(28, 28, 28);
  color: rgb(214, 214, 214);
}

/* * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  } */

.container {
  max-width: 1400px;
  padding: 0 15px;
  margin: 0 auto;
}

h2 {
  font-size: 32px;
  margin-bottom: 1em;
}

.cards {
  display: grid;
  grid-auto-columns: 100%;
  grid-column-gap: 10px;
  grid-auto-flow: column;
  padding: 25px 0px;
  list-style: none;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
}

.card {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: var(--white);
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 15%);
  scroll-snap-align: start;
  transition: all 0.2s;
}

.card:hover {
  color: var(--white);
  background: var(--orange);
}

.card .card-title {
  font-size: 20px;
}

.card .card-content {
  margin: 20px 0;
  max-width: 85%;
}

.card .card-link-wrapper {
  margin-top: auto;
}

.card:hover {
  cursor: pointer;
}

.card .card-link {
  display: inline-block;
  text-decoration: none;
  color: white;
  background: var(--orange);
  padding: 6px 12px;
  border-radius: 8px;
  transition: background 0.2s;
}

.card:hover .card-link {
  background: var(--darkorange);
}

.cards::-webkit-scrollbar {
  height: 12px;
}

.cards::-webkit-scrollbar-thumb,
.cards::-webkit-scrollbar-track {
  border-radius: 92px;
}

.cards::-webkit-scrollbar-thumb {
  background: var(--darkorange);
}

.cards::-webkit-scrollbar-track {
  background: var(--thumb);
}

@media (min-width: 500px) {
  .cards {
    grid-auto-columns: calc(50% - 10px);
    grid-column-gap: 20px;
  }
}

@media (min-width: 700px) {
  .cards {
    grid-auto-columns: calc(calc(100% / 3) - 20px);
    grid-column-gap: 30px;
  }
}

@media (min-width: 1100px) {
  .cards {
    grid-auto-columns: calc(calc(100% / 3) - 30px);
    grid-column-gap: 40px;
  }
}

#swipe-animation {
  position: relative;
  animation: myfirst 0.8s infinite;
  animation-direction: alternate;
}

@keyframes myfirst {
  0% {
    color: #fc4667 !important;
    left: 0px;
    top: 0px;
  }
  100% {
    color: black !important;
    left: -80px;
    top: 0px;
  }
}

.zoom {
  transition: transform 0.2s; /* Animation */
  margin: 0 auto;
}

.zoom:hover {
  transform: scale(
    1.15
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.lift-effect {
  will-change: transform;
  transition: transform 400ms;
}
.lift-effect:hover {
  transition: transform 150ms;
  transform: translateY(-20px);
}
</style>
